export default function getCurrentLocale() {
  const technicalDataEl = document.querySelector('[data-technical]');
  if (!technicalDataEl) return null;
  const data = JSON.parse(technicalDataEl.textContent);

  return `${data.localization.locale}`;
}